import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api, setSessionToken } from "@/lib/api";
import { useAuth } from "@/lib/auth";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
    const navigate = useNavigate();
    const location = useLocation();
    const processed = useRef(false);
    const { setUser } = useAuth();

    useEffect(() => {
        if (processed.current) return;
        processed.current = true;

        const params = new URLSearchParams(
            location.hash.replace(/^#/, ""),
        );
        const sessionId = params.get("session_id");
        if (!sessionId) {
            navigate("/", { replace: true });
            return;
        }
        (async () => {
            try {
                const { data } = await api.post("/auth/session", {
                    session_id: sessionId,
                });
                if (data?.session_token) setSessionToken(data.session_token);
                if (data?.user) setUser(data.user);
                navigate("/upload", { replace: true, state: { user: data?.user } });
            } catch (_) {
                navigate("/?auth_error=1", { replace: true });
            }
        })();
    }, [location.hash, navigate, setUser]);

    return (
        <div
            data-testid="auth-callback"
            className="min-h-screen bg-[#0A0A0C] text-white flex items-center justify-center"
        >
            <p className="text-sm text-white/60">Signing you in…</p>
        </div>
    );
}
